/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmspost_Og_Hint1Inputs */

const vi_cmspost_og_hint1 = /** @type {(inputs: Cmspost_Og_Hint1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ảnh hiện khi chia sẻ link bài lên Facebook, Zalo.`)
};

/**

* @param {Cmspost_Og_Hint1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmspost_og_hint1 = /** @type {((inputs?: Cmspost_Og_Hint1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmspost_Og_Hint1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmspost_og_hint1(inputs)
});
export { cmspost_og_hint1 as "cmsPost_og_hint" }